[
  {
    "id": "st-1",
    "clubId": "club-user",
    "staffType": "GOALKEEPER_COACH",
    "line": "GOALKEEPER",
    "role": "Entrenador de Porteros",
    "area": "goalkeeping",
    "level": 3,
    "starRating": 3,
    "cost": 450000,
    "salary": 450000,
    "version": 1
  },
  {
    "id": "st-2",
    "clubId": "club-user",
    "staffType": "PHYSICAL_COACH",
    "line": "DEFENCE",
    "role": "Entrenador de Defensas",
    "area": "fitness",
    "level": 4,
    "starRating": 4,
    "cost": 650000,
    "salary": 650000,
    "version": 1
  },
  {
    "id": "st-3",
    "clubId": "club-user",
    "staffType": "TECHNICAL_COACH",
    "line": "MIDFIELD",
    "role": "Entrenador de Centrocampistas",
    "area": "technical",
    "level": 3,
    "starRating": 3,
    "cost": 850000,
    "salary": 850000,
    "version": 1
  },
  {
    "id": "st-4",
    "clubId": "club-user",
    "staffType": "SHOOTING_COACH",
    "line": "FORWARD",
    "role": "Entrenador de Delanteros",
    "area": "shooting",
    "level": 4,
    "starRating": 4,
    "cost": 750000,
    "salary": 750000,
    "version": 1
  }
]
